import { Icon, IconProps } from '@chakra-ui/react';

export function BusinessPlanPictogram(props: IconProps) {
  return (
    <Icon aria-hidden='true' boxSize={8} viewBox='0 0 48 48' {...props}>
      <rect fill='#D2DFFF' height='48' rx='12' width='48' />
      <g fill='#175CFF'>
        <rect height='31.2' width='8.4' x='30.6' y='8.4' />
        <rect height='21.6' opacity='0.8' width='8.4' x='19.8' y='18' />
        <rect height='9.6' opacity='0.64' width='8.4' x='9' y='30' />
      </g>
    </Icon>
  );
}

export function ReceiptPictogram(props: IconProps) {
  return (
    <Icon aria-hidden='true' boxSize={8} viewBox='0 0 48 48' {...props}>
      <rect fill='#F6DFFF' height='48' rx='6' width='48' />
      <rect fill='#931CF5' fillOpacity='0.8' height='32' width='28' x='10' y='8' />
      <rect fill='#F6DFFF' height='3' width='18' x='15' y='14' />
      <rect fill='#F6DFFF' height='3' width='12' x='15' y='22' />
      <rect fill='#F6DFFF' height='3' width='16' x='15' y='30' />
    </Icon>
  );
}

export function SendPictogram(props: IconProps) {
  return (
    <Icon aria-hidden='true' boxSize={8} viewBox='0 0 48 48' {...props}>
      <rect fill='#D2DFFF' height='48' rx='6' width='48' />
      <g transform='translate(28.213 19.783) rotate(45) translate(-16 -14)'>
        <path d='M16 0L32 28H0L16 0Z' fill='#175CFF' />
        <path d='M16 14L18 28H14L16 14Z' fill='#D2DFFF' />
      </g>
    </Icon>
  );
}
